import { SVGProps } from "react";

export const IconWhatsapp: React.FunctionComponent<SVGProps<SVGSVGElement>> = (
  props
) => {
  return (
    <svg
      width="24"
      height="24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        d="M16.58 13.986c-.25-.127-1.471-.723-1.7-.808-.228-.081-.393-.124-.56.127-.162.244-.64.804-.787.967-.146.163-.29.175-.537.065-.25-.127-1.051-.388-2.002-1.24-.742-.66-1.236-1.474-1.383-1.725-.147-.248-.017-.388.107-.511.114-.114.25-.287.378-.437.12-.15.159-.25.247-.413.081-.175.04-.312-.022-.436s-.56-1.35-.768-1.84c-.2-.484-.407-.423-.56-.423-.144-.013-.31-.013-.476-.013a.942.942 0 0 0-.664.3c-.228.25-.872.85-.872 2.06 0 1.215.891 2.39 1.015 2.565.127.163 1.755 2.663 4.252 3.737.595.25 1.058.4 1.419.525.595.188 1.14.162 1.569.1.475-.078 1.47-.602 1.68-1.188.212-.59.212-1.077.15-1.188-.062-.114-.225-.176-.475-.286l-.011.062Zm-4.528 6.139h-.013c-1.478 0-2.94-.4-4.216-1.15l-.3-.178-3.124.814.84-3.041-.202-.313a8.229 8.229 0 0 1-1.263-4.38c0-4.538 3.714-8.24 8.284-8.24 2.214 0 4.29.863 5.853 2.425a8.162 8.162 0 0 1 2.425 5.827c-.006 4.535-3.717 8.236-8.281 8.236h-.003Zm7.047-15.25C17.2 3.037 14.7 2 12.04 2c-5.485 0-9.951 4.447-9.955 9.912 0 1.745.456 3.447 1.329 4.954L2 22l5.28-1.377a10.081 10.081 0 0 0 4.76 1.208h.003c5.488 0 9.954-4.447 9.957-9.916a9.82 9.82 0 0 0-2.913-7.009l.012-.032Z"
        fill="currentColor"
      />
    </svg>
  );
};
